module.exports = __webpack_public_path__ + "static/Twizzlers-e46684affd47469ca6267f6f53f33166.jpg";